import React from 'react'
import TransactionList from '../../components/transaction/transaction-list'

export default function TransactionAllPage(): React.ReactElement {

   return <TransactionList/>
}
